/** Flush control edges on the next simulation frame, independent of the normal
 * socket heartbeat. Continuous analog/look changes still use the heartbeat. */
export function inputNeedsImmediateSend(input, previous) {
  if (!previous) return true;
  for (const axis of ['moveX', 'moveZ', 'moveY']) {
    if (Math.sign(input[axis] || 0) !== Math.sign(previous[axis] || 0)) return true;
  }
  return !!input.jump !== !!previous.jump || !!input.sprint !== !!previous.sprint ||
    (input.flightToggleSeq ?? 0) > (previous.flightToggleSeq ?? 0);
}
